/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HiredContract = {
  properties: {
    cnpj: {
      type: 'string',
      isRequired: true,
    },
    companyMainName: {
      type: 'string',
      isRequired: true,
    },
    providerId: {
      type: 'string',
      isRequired: true,
    },
    contracts: {
      type: 'array',
      contains: {
        properties: {
          id: {
            type: 'string',
          },
          templateName: {
            type: 'string',
          },
          status: {
            type: 'ContractStatus',
          },
          professionals: {
            type: 'array',
            contains: {
              type: 'string',
            },
          },
          specialties: {
            type: 'array',
            contains: {
              type: 'string',
            },
          },
          hirers: {
            type: 'array',
            contains: {
              type: 'HirerBasicInfo',
            },
          },
        },
      },
      isRequired: true,
    },
  },
} as const;
